/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ComplaintRecordQueryResponse } from './ComplaintRecordQueryResponse';
import {
    ComplaintRecordQueryResponseFromJSON,
    ComplaintRecordQueryResponseFromJSONTyped,
    ComplaintRecordQueryResponseToJSON,
} from './ComplaintRecordQueryResponse';

/**
 * 
 * @export
 * @interface DataComplaintQueryResponse
 */
export interface DataComplaintQueryResponse {
    /**
     * 
     * @type {Array<ComplaintRecordQueryResponse>}
     * @memberof DataComplaintQueryResponse
     */
    data: Array<ComplaintRecordQueryResponse>;
}

/**
 * Check if a given object implements the DataComplaintQueryResponse interface.
 */
export function instanceOfDataComplaintQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function DataComplaintQueryResponseFromJSON(json: any): DataComplaintQueryResponse {
    return DataComplaintQueryResponseFromJSONTyped(json, false);
}

export function DataComplaintQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataComplaintQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ComplaintRecordQueryResponseFromJSON)),
    };
}

export function DataComplaintQueryResponseToJSON(value?: DataComplaintQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(ComplaintRecordQueryResponseToJSON)),
    };
}

